import script from "./virus-trend-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./virus-trend-chart.vue?vue&type=script&lang=ts&setup=true"

import "./virus-trend-chart.vue?vue&type=style&index=0&id=1922d848&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1922d848"]])

export default __exports__